import React, { Component } from 'react'
import Routes from '../routes/routes'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import Script from 'react-load-script'

class App extends Component {
  render () {
    return (
      <>
        <Routes location={this.props.location} />
        <Script
          url='https://js.stripe.com/v3/'
        />
      </>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch)

const mapStateToProps = ({ data }) => ({
  data

})
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App))
